import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectBaseVictorsMedicalTugo = (state) => state.get('baseVictorsMedicalTugo');

const makeSelectBaseVictorsMedicalTugo = () => createSelector(
  selectBaseVictorsMedicalTugo,
  (BaseVictorsMedicalTugoState) => ({

    whatExpensesAreYouClaimingFor: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'whatExpensesAreYouClaimingFor']),
      []
    ),

    // Doctor Visit selectors
    doctorVisitTelemedicine: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'doctorVisitTelemedicine']),
      ''
    ),
    doctorVisitFirstVisit: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'doctorVisitFirstVisit']),
      ''
    ),
    doctorVisitFollowUp: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'doctorVisitFollowUp']),
      ''
    ),
    doctorVisitFollowUpFracture: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'doctorVisitFollowUpFracture']),
      ''
    ),
    infoOutpatientPhysicianFeesItems: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'infoOutpatientPhysicianFeesItems']) && BaseVictorsMedicalTugoState.getIn(['form', 'infoOutpatientPhysicianFeesItems']).toJS(),
      []
    ),
    infoFollowUpVisitItems: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'infoFollowUpVisitItems']) && BaseVictorsMedicalTugoState.getIn(['form', 'infoFollowUpVisitItems']).toJS(),
      []
    ),
    infoFollowUpFractureItems: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'infoFollowUpFractureItems']) && BaseVictorsMedicalTugoState.getIn(['form', 'infoFollowUpFractureItems']).toJS(),
      []
    ),
    infoTelemedicineItems: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'infoTelemedicineItems']) && BaseVictorsMedicalTugoState.getIn(['form', 'infoTelemedicineItems']).toJS(),
      []
    ),

    // Diagnostic Tests selectors
    infoDiagnosticTestsItems: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'infoDiagnosticTestsItems']) && BaseVictorsMedicalTugoState.getIn(['form', 'infoDiagnosticTestsItems']).toJS(),
      []
    ),

    // Prescription Drugs selectors
    infoPrescriptionDrugsItems: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'infoPrescriptionDrugsItems']) && BaseVictorsMedicalTugoState.getIn(['form', 'infoPrescriptionDrugsItems']).toJS(),
      []
    ),

    // Ambulance Services selectors
    ambulanceGroundService: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'ambulanceGroundService']),
      ''
    ),
    ambulanceAirService: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'ambulanceAirService']),
      ''
    ),
    infoGroundAmbulanceItems: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'infoGroundAmbulanceItems']) && BaseVictorsMedicalTugoState.getIn(['form', 'infoGroundAmbulanceItems']).toJS(),
      []
    ),
    infoAirAmbulanceItems: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'infoAirAmbulanceItems']) && BaseVictorsMedicalTugoState.getIn(['form', 'infoAirAmbulanceItems']).toJS(),
      []
    ),

    // Hospitalization selectors
    hospitalizationHospitalInvoice: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'hospitalizationHospitalInvoice']),
      ''
    ),
    hospitalizationPhysicianInvoice: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'hospitalizationPhysicianInvoice']),
      ''
    ),
    hospitalizationLabDiagnostic: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'hospitalizationLabDiagnostic']),
      ''
    ),
    hospitalizationOtherRelated: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'hospitalizationOtherRelated']),
      ''
    ),
    infoHospitalFeesItems: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'infoHospitalFeesItems']) && BaseVictorsMedicalTugoState.getIn(['form', 'infoHospitalFeesItems']).toJS(),
      []
    ),
    infoInpatientPhysicianFeesItems: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'infoInpatientPhysicianFeesItems']) && BaseVictorsMedicalTugoState.getIn(['form', 'infoInpatientPhysicianFeesItems']).toJS(),
      []
    ),
    infoXrayLabsDiagnosticsItems: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'infoXrayLabsDiagnosticsItems']) && BaseVictorsMedicalTugoState.getIn(['form', 'infoXrayLabsDiagnosticsItems']).toJS(),
      []
    ),
    infoOtherHospitalizationItems: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'infoOtherHospitalizationItems']) && BaseVictorsMedicalTugoState.getIn(['form', 'infoOtherHospitalizationItems']).toJS(),
      []
    ),

    // Essential Medical Appliances selectors
    infoEssentialMedicalAppliancesItems: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'infoEssentialMedicalAppliancesItems']) && BaseVictorsMedicalTugoState.getIn(['form', 'infoEssentialMedicalAppliancesItems']).toJS(),
      []
    ),

    // Private Duty Nursing selectors
    infoPrivateDutyNursingItems: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'infoPrivateDutyNursingItems']) && BaseVictorsMedicalTugoState.getIn(['form', 'infoPrivateDutyNursingItems']).toJS(),
      []
    ),

    // Fracture Treatment selectors
    infoFractureTreatmentItems: mapWithDefault(
      BaseVictorsMedicalTugoState,
      () => BaseVictorsMedicalTugoState.getIn(['form', 'infoFractureTreatmentItems']) && BaseVictorsMedicalTugoState.getIn(['form', 'infoFractureTreatmentItems']).toJS(),
      []
    ),
  })
);

const makeSelectBaseVictorsMedicalTugoErrors = () =>
  createSelector(selectBaseVictorsMedicalTugo, (state) => state.get('errors'));

export {
  makeSelectBaseVictorsMedicalTugo,
  makeSelectBaseVictorsMedicalTugoErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.BaseVictorsMedical/selectors.js